const kryginaGallery = [
  {
    id: 1,
    src: require("./images/krygina/4-1.jpg"),
  },
  {
    id: 2,
    src: require("./images/krygina/4-2.jpg"),
  },
  {
    id: 3,
    src: require("./images/krygina/4-3.jpg"),
  },
  {
    id: 4,
    src: require("./images/krygina/4-4.jpg"),
  },
  {
    id: 5,
    src: require("./images/krygina/4-5.jpg"),
  },
  {
    id: 6,
    src: require("./images/krygina/4-6.jpg"),
  },
  {
    id: 7,
    src: require("./images/krygina/4-7.jpg"),
  },
  {
    id: 8,
    src: require("./images/krygina/4-8.jpg"),
  },
  {
    id: 9,
    src: require("./images/krygina/4-9.jpg"),
  },
  {
    id: 10,
    src: require("./images/krygina/4-10.jpg"),
  },
];

export default kryginaGallery;
